export default "__VITE_ASSET__BbCx03G7__"